import 'slick-carousel/slick/slick'

export default class ItemsSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-items-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {

            // Loop through each slider and initialize slick individually to avoid conflicts if multiple sliders are on the same page.
            this.settings.$slider.each((index, element) => {
                const $slider = $(element);
                const sliderId = $slider.data('slider-id');

                $slider.slick({
                    autoplay: true,
                    autoplaySpeed: 5000,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    dots: true,
                    arrows: false,
                    infinite: false,
                    appendDots: $(`.js-items-slider-dots[data-slider-id="${sliderId}"]`),

                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                            },
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            },
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            },
                        },
                    ]
                });
            });
        }

    }

};

new ItemsSlider();